import { useDispatch } from "react-redux";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { useSignalsManagementViewModel } from "app/pages/sales-intelligence/sub-modules/signals/hooks/useSignalsManagementViewModel";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";
import type SignalTypeWithIcon from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalTypeWithIcon";
import {
    isSignalsManagementOpenAction,
    setInitialSelectedSignalType,
} from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";

import { StyledSignalsListTypes } from "./styles";

type SignalsApiListTypesIntentAccess = "salesApiSignalsIntent" | "intentSignalsResource";

type SignalsApiListTypesContainerProps = {
    intentAccess?: SignalsApiListTypesIntentAccess;
};

export const SignalsApiListTypesContainer = ({
    intentAccess = "salesApiSignalsIntent",
}: SignalsApiListTypesContainerProps) => {
    const dispatch = useDispatch();
    const signalsModel = useSignalsManagementViewModel();

    const isIntentSignalTypeEnabled =
        intentAccess === "intentSignalsResource"
            ? salesSettingsHelper.isIntentSignalsEnabled()
            : salesSettingsHelper.isSalesApiSignalsIntentEnabled;

    const validSignals = isIntentSignalTypeEnabled
        ? signalsModel.signalTypes
        : signalsModel.signalTypes.filter((signal: SignalTypeWithIcon) => signal.type !== SignalType.Intent);

    const handleSignalTypeClick = (signalType: SignalType) => {
        dispatch(setInitialSelectedSignalType(signalType));
        dispatch(isSignalsManagementOpenAction(true));
    };

    return (
        <StyledSignalsListTypes
            signalTypes={validSignals}
            signalsCountPerType={signalsModel.signalsCountPerType}
            onSignalTypeClick={handleSignalTypeClick}
            data-automation="signals-api-list-per-type-container"
        />
    );
};
